import Vue from 'vue';
import user from './user';

const app = {
    state: {//属性
        menuList:[],//菜单列表
        headMenuTree:[],//头部菜单树
        isJumpMenuAnchor:false,//是否跳转菜单锚点
        isShowAppStore:false,//是否展示应用市场
        noticeTotal:0,//通知总数
        mailUnReadNum:0,//邮件未读数
        noticeUnReadNum:0,//未读通知总数
        trainMsgUnReadNum: 0,//培训未读消息数
        actMsgUnReadNum:0,// 活动未读消息数
    },
    mutations: {//set方法
        headMenuTree(state,menu){
            state.headMenuTree = menu;
        }
    },
    actions: {//其他方法
        // user_fillLoginInfo({ commit, state }, info) {//填充登录信息
        //     return new Promise((resolve, reject) => {
        //         resolve()
        //     })
        // }
    }
}

export default app;
